import {
  DialogProps as MantineDialogProps,
  Dialog as MantineDialog,
} from '@mantine/core';

export type DialogProps = MantineDialogProps;

export const Dialog = MantineDialog;

Dialog.displayName = 'Dialog';
